import walletIcon from "assets/images/wallet.svg";
import { EmptySection } from "../../shared/EmptySection";

export const EmptyIncomeSection = () => {
  // action

  return <EmptySection img={walletIcon} title="Kontroluj wpływy" />;
};
